var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#05d5e3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-407.501 -597.329)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M415.5,597.329h0a8,8,0,0,0-8,8h0a8,8,0,0,0,8,8h0a8,8,0,0,0,8-8h0A8,8,0,0,0,415.5,597.329Zm5.45,6.34a.845.845,0,0,1-1.2,0l-.6-.6-.6.6.6.6a.846.846,0,0,1-1.2,1.2l-.6-.6-1.282,1.282a3.373,3.373,0,1,1-1.192-1.2h0l4.867-4.867,1.2,1.2-.6.6.6.6A.845.845,0,0,1,420.951,603.669Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.691,
    cy: 1.691,
    r: 1.691,
    transform: "translate(411.486 606.164)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.2fb771eb13b6b8deaf083095a7159964.svg";
export { ForwardRef as ReactComponent };